var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProfilei = function SvgProfilei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Trigger Area"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M17.124 13.603a5.8 5.8 0 0 0-2.184-1.481 4.607 4.607 0 1 0-5.887 0 5.8 5.8 0 0 0-2.183 1.48 8.3 8.3 0 0 0-1.852 5.759.8.8 0 0 0 .8.738h12.361a.8.8 0 0 0 .8-.738 8.32 8.32 0 0 0-1.855-5.758m-8.135-5a3.007 3.007 0 1 1 3.008 3.007 3.01 3.01 0 0 1-3.012-3.002zm-2.368 9.892a6.25 6.25 0 0 1 1.43-3.819 6.04 6.04 0 0 1 7.892 0 6.26 6.26 0 0 1 1.431 3.818z",
    "data-name": "Path 10982"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProfilei);
export default ForwardRef;